import React from "react";
import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Flex,
} from "@chakra-ui/react";
import i18n from "../../i18n/i18n";
import IconArrowLinear from "../../assets/icons/IconArrowLinear";
import { colors } from "../../definitions/constants/GlobalStyles";
import BodyText from "../Common/BodyText";
import { InputErrorIcon } from "../../definitions/constants/IconsComponent";

interface CustomMenuSelectProps {
  labelName: string;
  selectedDescription: string;
  setSelectedDescription: (phase: string) => void;
  options: Record<string, string>;
  isMatch?: boolean;
  isInvalid?: boolean;
  error?: string;
}

const CustomMenuSelect: React.FC<CustomMenuSelectProps> = ({
  labelName,
  selectedDescription,
  setSelectedDescription,
  options,
  isMatch = false,
  isInvalid = false,
  error,
}) => {
  return (
    <FormControl
      display="flex"
      gap={1}
      flexDirection={"column"}
      width="100%"
      isRequired={true}
      isInvalid={isInvalid}
      marginBottom="-4px"
    >
      <Flex gap={1} alignItems="center">
        <FormLabel {...formLabelStyle} requiredIndicator={null}>
          {labelName}
        </FormLabel>
        <BodyText
          fontSize={{ base: "12px", md: "13px" }}
          fontWeight="regular"
          textColor={colors.text.lightGray3}
        >
          {i18n.t("required")}
        </BodyText>
      </Flex>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<Box as={IconArrowLinear} transform={"rotate(90deg)"} />}
          bg="white"
          border="1px solid"
          borderColor={isInvalid ? "red.500" : colors.backgrounds.gray1}
          borderRadius={20}
          textAlign="left"
          fontSize="14px"
          fontWeight="400"
          height="60px"
          _hover={{
            bg: "white",
          }}
          _active={{
            bg: "white",
          }}
          width="100%"
          color={colors.text.lightGray3}
          style={{
            boxShadow: isInvalid ? "0 0 0 1px #E53E3E" : "none",
          }}
        >
          {i18n.t(selectedDescription) || i18n.t("selectOption")}
        </MenuButton>
        <Box className="custom-width">
          <MenuList
            gap={1}
            padding={2}
            border="1px solid"
            borderColor={colors.backgrounds.gray1}
            borderRadius={16}
          >
            {Object.values(options).map((item: any) => (
              <MenuItem
                padding="0 16px"
                borderRadius={12}
                fontSize="13px"
                fontWeight="400"
                height="40px"
                key={item}
                color={colors.text.lightGray3}
                onClick={() => setSelectedDescription(item)}
              >
                {isMatch ? item.name : i18n.t(item)}
              </MenuItem>
            ))}
          </MenuList>
        </Box>
      </Menu>
      {error && (
        <FormErrorMessage color="red.500" gap="4px">
          <InputErrorIcon />
          <BodyText color="red.500">{error || i18n.t("input_error")}</BodyText>
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default CustomMenuSelect;

const formLabelStyle = {
  fontSize: "14px",
  fontWeight: "600",
  color: colors.text.black,
  margin: 0,
  paddingLeft: 4,
};